export default "__VITE_ASSET__v_8Fj8mN__"